"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _ApiClient = _interopRequireDefault(require("../ApiClient"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * The FeatureFlags model module.
 * @module model/FeatureFlags
 * @version 2.7.64
 */
var FeatureFlags = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>FeatureFlags</code>.
   * Read-only set of boolean flags that describe what features a Company has enabled 
   * @alias module:model/FeatureFlags
   */
  function FeatureFlags() {
    _classCallCheck(this, FeatureFlags);

    FeatureFlags.initialize(this);
  }
  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */


  _createClass(FeatureFlags, null, [{
    key: "initialize",
    value: function initialize(obj) {}
    /**
     * Constructs a <code>FeatureFlags</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/FeatureFlags} obj Optional instance to populate.
     * @return {module:model/FeatureFlags} The populated <code>FeatureFlags</code> instance.
     */

  }, {
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new FeatureFlags();

        if (data.hasOwnProperty('alerts_dashboard_enabled')) {
          obj['alerts_dashboard_enabled'] = _ApiClient["default"].convertToType(data['alerts_dashboard_enabled'], 'Boolean');
        }

        if (data.hasOwnProperty('analytics_enabled')) {
          obj['analytics_enabled'] = _ApiClient["default"].convertToType(data['analytics_enabled'], 'Boolean');
        }

        if (data.hasOwnProperty('automatic_carrier_policy_enabled')) {
          obj['automatic_carrier_policy_enabled'] = _ApiClient["default"].convertToType(data['automatic_carrier_policy_enabled'], 'Boolean');
        }

        if (data.hasOwnProperty('bid_manager_enabled')) {
          obj['bid_manager_enabled'] = _ApiClient["default"].convertToType(data['bid_manager_enabled'], 'Boolean');
        }

        if (data.hasOwnProperty('can_book_manual_shipments')) {
          obj['can_book_manual_shipments'] = _ApiClient["default"].convertToType(data['can_book_manual_shipments'], 'Boolean');
        }

        if (data.hasOwnProperty('can_initiate_mobile_ping_tracking')) {
          obj['can_initiate_mobile_ping_tracking'] = _ApiClient["default"].convertToType(data['can_initiate_mobile_ping_tracking'], 'Boolean');
        }

        if (data.hasOwnProperty('can_override_bill_to_for_automated_ltl')) {
          obj['can_override_bill_to_for_automated_ltl'] = _ApiClient["default"].convertToType(data['can_override_bill_to_for_automated_ltl'], 'Boolean');
        }

        if (data.hasOwnProperty('ceva_enabled')) {
          obj['ceva_enabled'] = _ApiClient["default"].convertToType(data['ceva_enabled'], 'Boolean');
        }

        if (data.hasOwnProperty('ch_robinson_enabled')) {
          obj['ch_robinson_enabled'] = _ApiClient["default"].convertToType(data['ch_robinson_enabled'], 'Boolean');
        }

        if (data.hasOwnProperty('company')) {
          obj['company'] = _ApiClient["default"].convertToType(data['company'], 'String');
        }

        if (data.hasOwnProperty('contracts_enabled')) {
          obj['contracts_enabled'] = _ApiClient["default"].convertToType(data['contracts_enabled'], 'Boolean');
        }

        if (data.hasOwnProperty('datadocks_enabled')) {
          obj['datadocks_enabled'] = _ApiClient["default"].convertToType(data['datadocks_enabled'], 'Boolean');
        }

        if (data.hasOwnProperty('edi_invoicing_enabled')) {
          obj['edi_invoicing_enabled'] = _ApiClient["default"].convertToType(data['edi_invoicing_enabled'], 'Boolean');
        }

        if (data.hasOwnProperty('fedex_enabled')) {
          obj['fedex_enabled'] = _ApiClient["default"].convertToType(data['fedex_enabled'], 'Boolean');
        }

        if (data.hasOwnProperty('freightwaves_driver_texts_enabled')) {
          obj['freightwaves_driver_texts_enabled'] = _ApiClient["default"].convertToType(data['freightwaves_driver_texts_enabled'], 'Boolean');
        }

        if (data.hasOwnProperty('ftl_instant_rates_enabled')) {
          obj['ftl_instant_rates_enabled'] = _ApiClient["default"].convertToType(data['ftl_instant_rates_enabled'], 'Boolean');
        }

        if (data.hasOwnProperty('genesis_ltl_enabled')) {
          obj['genesis_ltl_enabled'] = _ApiClient["default"].convertToType(data['genesis_ltl_enabled'], 'Boolean');
        }

        if (data.hasOwnProperty('historical_pricing_enabled')) {
          obj['historical_pricing_enabled'] = _ApiClient["default"].convertToType(data['historical_pricing_enabled'], 'Boolean');
        }

        if (data.hasOwnProperty('integrations_enabled')) {
          obj['integrations_enabled'] = _ApiClient["default"].convertToType(data['integrations_enabled'], 'Boolean');
        }

        if (data.hasOwnProperty('invoicing_enabled')) {
          obj['invoicing_enabled'] = _ApiClient["default"].convertToType(data['invoicing_enabled'], 'Boolean');
        }

        if (data.hasOwnProperty('load_board_enabled')) {
          obj['load_board_enabled'] = _ApiClient["default"].convertToType(data['load_board_enabled'], 'Boolean');
        }

        if (data.hasOwnProperty('mfa_enabled')) {
          obj['mfa_enabled'] = _ApiClient["default"].convertToType(data['mfa_enabled'], 'Boolean');
        }

        if (data.hasOwnProperty('netsuite_enabled')) {
          obj['netsuite_enabled'] = _ApiClient["default"].convertToType(data['netsuite_enabled'], 'Boolean');
        }

        if (data.hasOwnProperty('new_dashboard_enabled')) {
          obj['new_dashboard_enabled'] = _ApiClient["default"].convertToType(data['new_dashboard_enabled'], 'Boolean');
        }

        if (data.hasOwnProperty('order_consolidation_workflows_enabled')) {
          obj['order_consolidation_workflows_enabled'] = _ApiClient["default"].convertToType(data['order_consolidation_workflows_enabled'], 'Boolean');
        }

        if (data.hasOwnProperty('policies_enabled')) {
          obj['policies_enabled'] = _ApiClient["default"].convertToType(data['policies_enabled'], 'Boolean');
        }

        if (data.hasOwnProperty('purchase_orders_enabled')) {
          obj['purchase_orders_enabled'] = _ApiClient["default"].convertToType(data['purchase_orders_enabled'], 'Boolean');
        }

        if (data.hasOwnProperty('rate_tables_enabled')) {
          obj['rate_tables_enabled'] = _ApiClient["default"].convertToType(data['rate_tables_enabled'], 'Boolean');
        }

        if (data.hasOwnProperty('rmis_enabled')) {
          obj['rmis_enabled'] = _ApiClient["default"].convertToType(data['rmis_enabled'], 'Boolean');
        }

        if (data.hasOwnProperty('saferwatch_enabled')) {
          obj['saferwatch_enabled'] = _ApiClient["default"].convertToType(data['saferwatch_enabled'], 'Boolean');
        }

        if (data.hasOwnProperty('send_shipwell_network_enabled')) {
          obj['send_shipwell_network_enabled'] = _ApiClient["default"].convertToType(data['send_shipwell_network_enabled'], 'Boolean');
        }

        if (data.hasOwnProperty('shipment_details_redesign_enabled')) {
          obj['shipment_details_redesign_enabled'] = _ApiClient["default"].convertToType(data['shipment_details_redesign_enabled'], 'Boolean');
        }

        if (data.hasOwnProperty('show_load_board')) {
          obj['show_load_board'] = _ApiClient["default"].convertToType(data['show_load_board'], 'Boolean');
        }

        if (data.hasOwnProperty('stop_status_enabled')) {
          obj['stop_status_enabled'] = _ApiClient["default"].convertToType(data['stop_status_enabled'], 'Boolean');
        }

        if (data.hasOwnProperty('supplier_invites_enabled')) {
          obj['supplier_invites_enabled'] = _ApiClient["default"].convertToType(data['supplier_invites_enabled'], 'Boolean');
        }

        if (data.hasOwnProperty('triumph_pay_enabled')) {
          obj['triumph_pay_enabled'] = _ApiClient["default"].convertToType(data['triumph_pay_enabled'], 'Boolean');
        }

        if (data.hasOwnProperty('ups_enabled')) {
          obj['ups_enabled'] = _ApiClient["default"].convertToType(data['ups_enabled'], 'Boolean');
        }

        if (data.hasOwnProperty('uses_3pl_quoting_flow')) {
          obj['uses_3pl_quoting_flow'] = _ApiClient["default"].convertToType(data['uses_3pl_quoting_flow'], 'Boolean');
        }

        if (data.hasOwnProperty('usps_enabled')) {
          obj['usps_enabled'] = _ApiClient["default"].convertToType(data['usps_enabled'], 'Boolean');
        }
      }

      return obj;
    }
  }]);

  return FeatureFlags;
}();
/**
 * Flag that allows a company to use alerts dashboard
 * @member {Boolean} alerts_dashboard_enabled
 */


FeatureFlags.prototype['alerts_dashboard_enabled'] = undefined;
/**
 * Flag that enables analytics capability
 * @member {Boolean} analytics_enabled
 */

FeatureFlags.prototype['analytics_enabled'] = undefined;
/**
 * Flag that allows for automatic carrier policy feature to be enabled
 * @member {Boolean} automatic_carrier_policy_enabled
 */

FeatureFlags.prototype['automatic_carrier_policy_enabled'] = undefined;
/**
 * Flag that allows users to use the bid manager feature
 * @member {Boolean} bid_manager_enabled
 */

FeatureFlags.prototype['bid_manager_enabled'] = undefined;
/**
 * Flag that notifies the frontend whether or not it should display manual shipment booking pages 
 * @member {Boolean} can_book_manual_shipments
 */

FeatureFlags.prototype['can_book_manual_shipments'] = undefined;
/**
 * Flag that allows a company to initiate cell phone ping tracking requests 
 * @member {Boolean} can_initiate_mobile_ping_tracking
 */

FeatureFlags.prototype['can_initiate_mobile_ping_tracking'] = undefined;
/**
 * Flag that notifies the frontend whether or not to render bill-to override dialog for autobook LTL shipments 
 * @member {Boolean} can_override_bill_to_for_automated_ltl
 */

FeatureFlags.prototype['can_override_bill_to_for_automated_ltl'] = undefined;
/**
 * Flag that designates a company as a CEVA customer
 * @member {Boolean} ceva_enabled
 */

FeatureFlags.prototype['ceva_enabled'] = undefined;
/**
 * Flag that allows shipments created by Company to create and delete CHR Orders if CHR customer code is also set
 * @member {Boolean} ch_robinson_enabled
 */

FeatureFlags.prototype['ch_robinson_enabled'] = undefined;
/**
 * @member {String} company
 */

FeatureFlags.prototype['company'] = undefined;
/**
 * Flag that allows user to use contracts and SLAs
 * @member {Boolean} contracts_enabled
 */

FeatureFlags.prototype['contracts_enabled'] = undefined;
/**
 * Flag that enables DataDocks integration 
 * @member {Boolean} datadocks_enabled
 */

FeatureFlags.prototype['datadocks_enabled'] = undefined;
/**
 * Flag that allows a company to dispatch invoices via EDI
 * @member {Boolean} edi_invoicing_enabled
 */

FeatureFlags.prototype['edi_invoicing_enabled'] = undefined;
/**
 * Flag that enables Fedex capabilities
 * @member {Boolean} fedex_enabled
 */

FeatureFlags.prototype['fedex_enabled'] = undefined;
/**
 * Temp flag that allows user to see the freightwaves demo functionality
 * @member {Boolean} freightwaves_driver_texts_enabled
 */

FeatureFlags.prototype['freightwaves_driver_texts_enabled'] = undefined;
/**
 * Flag that enables a companies usage of FTL Instant Rates
 * @member {Boolean} ftl_instant_rates_enabled
 */

FeatureFlags.prototype['ftl_instant_rates_enabled'] = undefined;
/**
 * Flag that allows a company to access Genesis LTL
 * @member {Boolean} genesis_ltl_enabled
 */

FeatureFlags.prototype['genesis_ltl_enabled'] = undefined;
/**
 * Flag that allows user to view historical pricing data visualization
 * @member {Boolean} historical_pricing_enabled
 */

FeatureFlags.prototype['historical_pricing_enabled'] = undefined;
/**
 * Flag that enables third party applications supported on the platform capability
 * @member {Boolean} integrations_enabled
 */

FeatureFlags.prototype['integrations_enabled'] = undefined;
/**
 * Flag that allows users of the company to access invoicing features.
 * @member {Boolean} invoicing_enabled
 */

FeatureFlags.prototype['invoicing_enabled'] = undefined;
/**
 * Flag that allows users of the company to post shipments to the load board
 * @member {Boolean} load_board_enabled
 */

FeatureFlags.prototype['load_board_enabled'] = undefined;
/**
 * Whether or not multifactor authentication is enabled for all users within this company
 * @member {Boolean} mfa_enabled
 */

FeatureFlags.prototype['mfa_enabled'] = undefined;
/**
 * Flag that allows a company to use Netsuite
 * @member {Boolean} netsuite_enabled
 */

FeatureFlags.prototype['netsuite_enabled'] = undefined;
/**
 * Flag that allows user to see the new dashboard views
 * @member {Boolean} new_dashboard_enabled
 */

FeatureFlags.prototype['new_dashboard_enabled'] = undefined;
/**
 * Flag that allows a company to use order consolidation workflows
 * @member {Boolean} order_consolidation_workflows_enabled
 */

FeatureFlags.prototype['order_consolidation_workflows_enabled'] = undefined;
/**
 * Flag that allows user to use policies
 * @member {Boolean} policies_enabled
 */

FeatureFlags.prototype['policies_enabled'] = undefined;
/**
 * Flag that enables purchase order capability
 * @member {Boolean} purchase_orders_enabled
 */

FeatureFlags.prototype['purchase_orders_enabled'] = undefined;
/**
 * Flag that allows fuel and accessorial rate tables to be rendered
 * @member {Boolean} rate_tables_enabled
 */

FeatureFlags.prototype['rate_tables_enabled'] = undefined;
/**
 * Flag that enables syncing carrier profile data from RMIS
 * @member {Boolean} rmis_enabled
 */

FeatureFlags.prototype['rmis_enabled'] = undefined;
/**
 * Flag that enables syncing carrier profile data from SaferWatch
 * @member {Boolean} saferwatch_enabled
 */

FeatureFlags.prototype['saferwatch_enabled'] = undefined;
/**
 * Flag that allows users to send quotes to the shipwell network
 * @member {Boolean} send_shipwell_network_enabled
 */

FeatureFlags.prototype['send_shipwell_network_enabled'] = undefined;
/**
 * Flag that allows for enabling usage of newly redesigned shipment detail
 * @member {Boolean} shipment_details_redesign_enabled
 */

FeatureFlags.prototype['shipment_details_redesign_enabled'] = undefined;
/**
 * Flag that notifies the frontend whether or not to display the load board
 * @member {Boolean} show_load_board
 */

FeatureFlags.prototype['show_load_board'] = undefined;
/**
 * Flag that allows stop statuses to be enabled
 * @member {Boolean} stop_status_enabled
 */

FeatureFlags.prototype['stop_status_enabled'] = undefined;
/**
 * Flag that enables a company from sending supplier invite links
 * @member {Boolean} supplier_invites_enabled
 */

FeatureFlags.prototype['supplier_invites_enabled'] = undefined;
/**
 * Flag that enables company to use the Triumph Pay integration
 * @member {Boolean} triumph_pay_enabled
 */

FeatureFlags.prototype['triumph_pay_enabled'] = undefined;
/**
 * Flag that enables UPS capabilities
 * @member {Boolean} ups_enabled
 */

FeatureFlags.prototype['ups_enabled'] = undefined;
/**
 * Flag that instructs frontend to render the 3PL-specific quoting flow
 * @member {Boolean} uses_3pl_quoting_flow
 */

FeatureFlags.prototype['uses_3pl_quoting_flow'] = undefined;
/**
 * Flag that enables USPS capabilities
 * @member {Boolean} usps_enabled
 */

FeatureFlags.prototype['usps_enabled'] = undefined;
var _default = FeatureFlags;
exports["default"] = _default;